require("-!style!css!./../node_modules/vue-loader/lib/style-rewriter.js!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Tab.vue")
module.exports = require("-!babel?optional[]=runtime!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Tab.vue")
module.exports.template = require("-!vue-html!./../node_modules/vue-loader/lib/template-rewriter.js!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Tab.vue")



/*****************
 ** WEBPACK FOOTER
 ** ./src/Tab.vue
 ** module id = 141
 ** module chunks = 0
 **/